import { createContext, useContext } from 'react';
import {
  ControlField,
  FieldMetadata,
  Lookup,
} from '../../contexts/MetadataContext';
import { FieldPresentation } from '@brightmls/nextgen.lae.flc';

export interface FormFieldState {
  message: string;
  errorMessage: string;
  warningMessage: string;
  isError: boolean;
  isMessage: boolean;
  isWarning: boolean;
  isRequired: boolean;
  isDisabled: boolean;
  isReadOnly: boolean;
  isTouched: boolean;
  showRemaining: number | false;
}

export interface Option {
  value: string;
  label: string;
  description: string;
  metadata?: Lookup;
}

export interface FormFieldContextValue extends FormFieldState {
  field: ControlField;
  fieldMeta: FieldMetadata;
  fieldPresentation: FieldPresentation;
  fieldValue: any;
  fieldSourceValue?: any;
  options?: Option[];
  onFieldValueChange: (value: any) => void;
}

export const FormFieldContext = createContext<
  FormFieldContextValue | undefined
>(undefined);

export const useFormField = () => {
  const context = useContext(FormFieldContext);
  if (!context) {
    throw new Error('useFormField must be used within a FormFieldProvider');
  }
  return context;
};
